import styled from 'styled-components';
import { rem } from 'polished';

export const PageWrapper = styled.div`
  width: 100%;
`;

export const HeroSection = styled.section`
  padding: ${rem('120px')} ${rem('20px')} ${rem('80px')};
  background: linear-gradient(135deg, #dcfce7 0%, #bbf7d0 50%, #86efac 100%);
  position: relative;
  overflow: hidden;

  @media ${({ theme }) => theme.mediaQueries.mediumMax} {
    padding: ${rem('100px')} ${rem('16px')} ${rem('60px')};
  }
`;

export const HeroContainer = styled.div`
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${rem('60px')};
  align-items: center;
  position: relative;

  @media ${({ theme }) => theme.mediaQueries.mediumMax} {
    grid-template-columns: 1fr;
    gap: ${rem('40px')};
    text-align: center;
  }
`;

export const HeroContent = styled.div`
  width: 100%;
  max-width: 100%;
`;

export const HeroTitle = styled.h1`
  font-family: 'MontserratBlack', sans-serif;
  font-size: clamp(2.5rem, 5vw, 4rem);
  line-height: 1.1;
  color: #1a1a1a;
  margin-bottom: ${rem('20px')};
  font-weight: 800;
  letter-spacing: -1px;
  word-wrap: break-word;
  overflow-wrap: break-word;
`;

export const HeroSubtitle = styled.p`
  font-size: clamp(1.1rem, 2vw, 1.5rem);
  line-height: 1.5;
  color: #374151;
  margin-bottom: ${rem('32px')};
  font-weight: 500;
`;

export const HeroAnimationWrapper = styled.div`
  width: 100%;
  max-width: 400px;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;

  @media ${({ theme }) => theme.mediaQueries.mediumMax} {
    max-width: 350px;
    margin: 0 auto;
  }

  @media ${({ theme }) => theme.mediaQueries.smallMax} {
    max-width: 280px;
  }
`;

export const ProblemSolutionSection = styled.section`
  padding: ${rem('100px')} ${rem('20px')} ${rem('80px')};
  background: #f9fafb;

  @media ${({ theme }) => theme.mediaQueries.mediumMax} {
    padding: ${rem('70px')} ${rem('16px')} ${rem('60px')};
  }
`;

export const SectionContainer = styled.div`
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
`;

export const SectionTitle = styled.h2`
  font-family: 'MontserratBlack', sans-serif;
  font-size: clamp(1.8rem, 3.5vw, 2.5rem);
  line-height: 1.3;
  color: #1f2937;
  margin-bottom: ${rem('48px')};
  text-align: center;
  font-weight: 800;
  letter-spacing: -0.5px;
  word-wrap: break-word;
  overflow-wrap: break-word;
`;

export const ProblemsGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem('24px')};
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
`;

export const ProblemCard = styled.div`
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: ${rem('20px')};
  align-items: center;
  padding: ${rem('28px')} ${rem('32px')};
  background: white;
  border-radius: 12px;
  border-left: 4px solid #25d366;
  transition: all 0.2s ease;

  &:hover {
    background: #f0fdf4;
  }

  @media ${({ theme }) => theme.mediaQueries.mediumMax} {
    grid-template-columns: 1fr;
    text-align: center;
    border-left: none;
    border-top: 4px solid #25d366;
  }
`;

export const ProblemIcon = styled.div`
  font-size: ${rem('36px')};
  flex-shrink: 0;
`;

export const ProblemTitle = styled.h3`
  font-size: ${rem('18px')};
  color: #1f2937;
  margin-bottom: ${rem('6px')};
  font-weight: 700;
`;

export const ProblemText = styled.p`
  font-size: ${rem('15px')};
  color: #6b7280;
  line-height: 1.5;
  margin: 0;
`;

export const SolutionText = styled.p`
  font-size: ${rem('15px')};
  color: #166534;
  font-weight: 600;
  line-height: 1.5;
  background: #dcfce7;
  padding: ${rem('8px')} ${rem('16px')};
  border-radius: 8px;
  white-space: nowrap;
  flex-shrink: 0;

  &::before {
    content: '→ ';
    color: #25d366;
    font-weight: 700;
  }

  @media ${({ theme }) => theme.mediaQueries.mediumMax} {
    white-space: normal;
  }
`;

export const UseCasesSection = styled.section`
  padding: ${rem('100px')} ${rem('20px')};
  background: #1a1a1a;

  @media ${({ theme }) => theme.mediaQueries.mediumMax} {
    padding: ${rem('70px')} ${rem('16px')};
  }
`;

export const UseCasesTitle = styled.h2`
  font-family: 'MontserratBlack', sans-serif;
  font-size: clamp(1.8rem, 3.5vw, 2.5rem);
  line-height: 1.3;
  color: white;
  margin-bottom: ${rem('48px')};
  text-align: center;
  font-weight: 800;
  letter-spacing: -0.5px;
  word-wrap: break-word;
  overflow-wrap: break-word;
`;

export const UseCasesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: ${rem('32px')};
  width: 100%;

  @media ${({ theme }) => theme.mediaQueries.smallMax} {
    grid-template-columns: 1fr;
    gap: ${rem('24px')};
  }
`;

export const UseCaseCard = styled.div`
  background: #2d2d2d;
  padding: ${rem('28px')};
  border-radius: 16px;
  border: 2px solid #374151;
  transition: all 0.3s ease;

  &:hover {
    border-color: #25d366;
    transform: translateY(-4px);
  }
`;

export const UseCaseHeader = styled.div`
  display: flex;
  align-items: center;
  gap: ${rem('12px')};
  margin-bottom: ${rem('16px')};
`;

export const UseCaseIcon = styled.div`
  font-size: ${rem('32px')};
`;

export const UseCaseTitle = styled.h3`
  font-size: ${rem('18px')};
  color: white;
  margin: 0;
  font-weight: 700;
`;

export const UseCaseExample = styled.div`
  background: #1a1a1a;
  padding: ${rem('16px')};
  border-radius: 12px;
  border-left: 4px solid #25d366;
  margin-bottom: ${rem('12px')};
`;

export const UseCaseQuestion = styled.p`
  font-size: ${rem('15px')};
  color: #d1d5db;
  font-style: italic;
  margin: 0;
  line-height: 1.5;

  &::before {
    content: '"';
    color: #25d366;
  }

  &::after {
    content: '"';
    color: #25d366;
  }
`;

export const HowItWorksSection = styled.section`
  padding: ${rem('100px')} ${rem('20px')} ${rem('120px')};
  background: white;

  @media ${({ theme }) => theme.mediaQueries.mediumMax} {
    padding: ${rem('70px')} ${rem('16px')} ${rem('80px')};
  }
`;

export const StepsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0;
  max-width: 900px;
  margin: 0 auto;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: ${rem('28px')};
    left: calc(16.67% + ${rem('28px')});
    right: calc(16.67% + ${rem('28px')});
    height: 3px;
    background: #e5e7eb;
    z-index: 0;
  }

  @media ${({ theme }) => theme.mediaQueries.mediumMax} {
    grid-template-columns: 1fr;
    gap: ${rem('40px')};

    &::before {
      display: none;
    }
  }
`;

export const StepCard = styled.div`
  text-align: center;
  position: relative;
  z-index: 1;
`;

export const StepNumber = styled.div`
  width: ${rem('56px')};
  height: ${rem('56px')};
  border-radius: 50%;
  background: white;
  border: 3px solid #25d366;
  color: #166534;
  font-size: ${rem('22px')};
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto ${rem('20px')};
`;

export const StepTitle = styled.h3`
  font-size: ${rem('18px')};
  color: #1f2937;
  margin-bottom: ${rem('8px')};
  font-weight: 700;
`;

export const StepDescription = styled.p`
  font-size: ${rem('16px')};
  color: #6b7280;
  line-height: 1.6;
`;

export const PricingSection = styled.section`
  padding: ${rem('100px')} ${rem('20px')};
  background: #111827;
  position: relative;
  overflow: hidden;

  @media ${({ theme }) => theme.mediaQueries.mediumMax} {
    padding: ${rem('70px')} ${rem('16px')};
  }
`;

export const PricingCard = styled.div`
  max-width: 600px;
  margin: 0 auto;
  background: white;
  padding: ${rem('48px')};
  border-radius: 16px;
  border-top: 4px solid #25d366;

  @media ${({ theme }) => theme.mediaQueries.smallMax} {
    padding: ${rem('32px')} ${rem('24px')};
  }
`;

export const PricingTitle = styled.h2`
  font-family: 'MontserratBlack', sans-serif;
  font-size: clamp(1.8rem, 3.5vw, 2.5rem);
  color: white;
  text-align: center;
  margin-bottom: ${rem('48px')};
  font-weight: 800;
  letter-spacing: -0.5px;
`;

export const PriceTag = styled.div`
  text-align: center;
  margin-bottom: ${rem('32px')};
  padding-bottom: ${rem('24px')};
  border-bottom: 2px solid #e5e7eb;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const SetupFee = styled.div`
  font-size: ${rem('18px')};
  color: #6b7280;
  margin-bottom: ${rem('8px')};

  span {
    font-weight: 700;
    color: #1f2937;
  }
`;

export const MonthlyPrice = styled.div`
  font-family: 'MontserratBlack', sans-serif;
  font-size: ${rem('56px')};
  color: #1f2937;
  line-height: 1;
  font-weight: 800;

  span {
    font-size: ${rem('24px')};
    color: #6b7280;
  }
`;

export const PriceSubtext = styled.div`
  font-size: ${rem('16px')};
  color: #6b7280;
  margin-top: ${rem('8px')};
  text-align: center;
`;

export const FeaturesList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0 0 ${rem('32px')} 0;
`;

export const FeatureItem = styled.li`
  font-size: ${rem('16px')};
  color: #374151;
  padding: ${rem('12px')} 0;
  border-bottom: 1px solid #f3f4f6;
  display: flex;
  align-items: center;
  gap: ${rem('12px')};

  &:last-child {
    border-bottom: none;
  }

  &::before {
    content: '✓';
    color: #25d366;
    font-weight: 700;
    font-size: ${rem('20px')};
  }
`;

export const CTAButton = styled.button`
  width: 100%;
  padding: ${rem('16px')} ${rem('32px')};
  background: #25d366;
  color: white;
  font-size: ${rem('18px')};
  font-weight: 700;
  border: 2px solid #25d366;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: center;
  display: block;
  margin: 0 auto;

  &:hover {
    background: #1a1a1a;
    color: #25d366;
  }

  &:active {
    transform: translateY(0);
  }
`;

export const FAQSection = styled.section`
  padding: ${rem('60px')} ${rem('20px')} ${rem('100px')};
  background: #f9fafb;

  @media ${({ theme }) => theme.mediaQueries.mediumMax} {
    padding: ${rem('50px')} ${rem('16px')} ${rem('70px')};
  }
`;

export const FAQContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
`;

export const FAQItem = styled.div`
  background: white;
  padding: ${rem('24px')};
  border-radius: 12px;
  margin-bottom: ${rem('16px')};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
`;

export const FAQQuestion = styled.h3`
  font-size: ${rem('17px')};
  color: #1f2937;
  margin-bottom: ${rem('10px')};
  font-weight: 700;
`;

export const FAQAnswer = styled.p`
  font-size: ${rem('16px')};
  color: #6b7280;
  line-height: 1.6;
  margin: 0;
`;

export const SupermanImage = styled.img`
  width: ${rem('100px')};
  height: auto;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.15));
  padding: ${rem('8px')};

  @media ${({ theme }) => theme.mediaQueries.mediumMax} {
    width: ${rem('80px')};
    padding: ${rem('6px')};
  }

  @media ${({ theme }) => theme.mediaQueries.smallMax} {
    width: ${rem('60px')};
    padding: ${rem('4px')};
  }
`;

export const SupermanWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: ${rem('16px')};
  margin-top: ${rem('-50px')};

  @media ${({ theme }) => theme.mediaQueries.mediumMax} {
    margin-top: ${rem('-40px')};
  }

  @media ${({ theme }) => theme.mediaQueries.smallMax} {
    display: none;
  }
`;
